<template>
  <i :class="{'disabled': disabled || readonly}" @click="click" class="material-icons"><slot></slot></i>
</template>

<script>
export default {
  props: ["disabled", "readonly"],
  methods: {
    click() {
      if (this.disabled || this.readonly) {
        return;
      }
      this.$emit("click");
    }
  }

}
</script>

<style lang="less" scope>
.disabled {
  opacity: 0.3;
}
</style>
